// eslint-disable-next-line import/no-named-as-default
import Icon from "@mdi/react";

import { mdiFileTreeOutline } from "@mdi/js";

import { useSelectItemsAction } from "../hooks/useSelectItemsAction";
import { ShapefileAction } from "../nodes/StyledNodePartials";

interface SelectItemsActionProps {
  isDisabled?: boolean;
  setPopoverOpen?: (isOpen: boolean) => void;
  onContextMenuClose?: () => void;
}

export function SelectItemsAction({
  isDisabled: isDisabledLocal,
  setPopoverOpen,
  onContextMenuClose
}: SelectItemsActionProps) {
  const { isDisabled, handleSelectItems, actionText } = useSelectItemsAction({
    isDisabled: isDisabledLocal,
    setPopoverOpen,
    onContextMenuClose
  });

  const handleClick = (event: React.MouseEvent) => {
    if (isDisabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    handleSelectItems(event);
  };

  return (
    <ShapefileAction disabled={isDisabled} placement="bottom" onClick={handleClick}>
      <Icon path={mdiFileTreeOutline} size={"18px"} />
      {actionText}
    </ShapefileAction>
  );
}
